// settings entries flagged RequiresExternalPension (drawer items, dashboard tiles) are member-level
export const forExternalPension = (items, isExternalPensionMember) =>
  items?.filter((i) => !i.RequiresExternalPension || isExternalPensionMember);
